import { type MouseEventHandler } from 'react';
import { translate } from '@/core/localization/translate';
import { IconButton } from '@/core/tamagoshiTailwind/components/IconButton/IconButton';
import { H3 } from '@/core/tamagoshiTailwind/components/Typography/Typography';
import { CrossIcon } from '@/core/tamagoshiTailwind/icons/CrossIcon';
export const {
  closeButtonAriaLabel
} = translate({
  "closeButtonAriaLabel": "Close"
});
type HeaderProps = {
  onClose: MouseEventHandler<HTMLButtonElement>;
  title: string;
};
export const Header = ({
  onClose,
  title
}: HeaderProps) => <div className="flex items-start justify-between">
    <H3 className="line-clamp-2">{title}</H3>
    <IconButton aria-label={closeButtonAriaLabel} icon={CrossIcon} onClick={onClose} />
  </div>;
Header.displayName = 'Header';